import {
  EditLodgingRequestDatesState,
  EditLodgingRequestDatesActionTypes,
  EDIT_LODGING_REQUEST_DATES_REQUEST,
  EDIT_LODGING_REQUEST_DATES_SUCCESS,
  EDIT_LODGING_REQUEST_DATES_FAILURE
} from 'store/reducers/lodgingRequest/edit-dates/types';

const defaultState: EditLodgingRequestDatesState = {
  isLoading: false,
  errorMessage: ''
};

export default function editLodgingRequestDates(state = defaultState, action: EditLodgingRequestDatesActionTypes): EditLodgingRequestDatesState {
  switch (action.type) {
    case EDIT_LODGING_REQUEST_DATES_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case EDIT_LODGING_REQUEST_DATES_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ''
      };
    case EDIT_LODGING_REQUEST_DATES_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ''
      };
    default:
      return state;
  }
};